// extracted by mini-css-extract-plugin
export default {"price":"E6-z","onSale":"F6-z","msrpLabelPrice":"G6-z","msrpLabel":"H6-z","originalPrice":"I6-z","percentOff":"J6-z"};